<template>
  <Page current-link="register">
    <div class="form col-center">
      <TitleLg>Create Account</TitleLg>
      <div style="height: 30px;"></div>
      <FormSection>
        <form name="register" @submit.prevent="doRegister">
          <input type="hidden" name="form-name" value="register"/>
          <div class="input-container input">
            <input v-model="firstName" autocomplete="given-name" required/>
            <label for="firstName">First Name</label>
          </div>
          <div class="input-container input">
            <input v-model="lastName" autocomplete="family-name" required/>
            <label for="lastName">Last Name</label>
          </div>
          <div class="input-container input">
            <input v-model="email" type="email" autocomplete="email" required/>
            <label for="email">Email</label>
          </div>
          <CountrySelect v-model="selectedLocation"/>
          <div class="input-container input">
            <input
                v-model="password"
                type="password"
                autocomplete="new-password"
                required
            />
            <label for="password">Password</label>
          </div>
          <div class="input-container input">
            <input
                v-model="confirmPassword"
                type="password"
                autocomplete="new-password"
                required
            />
            <label for="password">Confirm Password</label>
          </div>
          <div class="col-center">
            <div>
              <input type="checkbox" id="agree" name="agree" v-model="agreeToTerms" style="width: revert;"/>
              <label for="agree" style="position: relative;">
                I agree to terms and conditions
              </label>
            </div>
          </div>
          <button class="button" type="submit">Register</button>
        </form>
      </FormSection>
    </div>
    <!--    <button class="button" @click="doRegister">Register</button>-->
  </Page>
</template>

<script setup lang="ts">
const firstName = ref('');
const lastName = ref('');
const email = ref('');
const password = ref('');
const confirmPassword = ref('');
const agreeToTerms = ref(false);
const selectedLocation = ref({
  country: '',
  province: '',
});

async function doRegister() {
  if (password.value.trim() === '') {
    alert('Password not entered.');
    return;
  }

  if (confirmPassword.value.trim() === '') {
    alert('Confirm Password not entered.');
    return;
  }

  if (password.value !== confirmPassword.value) {
    alert('Passwords do not match.');
    return;
  }

  if (!agreeToTerms.value) {
    alert('You must agree to the terms and conditions.');
    return;
  }

  try {
    const {data, error} = await useFetch('/api/customer', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: {
        firstName: firstName.value,
        lastName: lastName.value,
        email: email.value,
        password: password.value,
        confirmPassword: confirmPassword.value,
        country: selectedLocation.value.country,
        province: selectedLocation.value.province,
        // addresses: [
        //   {
        //     country: selectedLocation.value.country,
        //     province: province.value,
        //   },
        // ],
      },
    });

    if (error.value) {
      throw error.value;
    }
    if (data.value) {
      // console.log(JSON.stringify(data.value));
      alert('Registration successful.');
      navigateTo('/login');
    }
  } catch (error) {
    alert('Error occurred during registration.');
  }
}
</script>
